import {
    AfterContentInit,
    Directive,
    HostListener,
    Inject,
    Input,
} from "@angular/core";
import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { CommonFormManagerDirective } from "../form-manager.directive";
import { FORM_FIELD_GROUP_STATE_PROP } from "../state-props";

@Directive({
    selector: "[common-group-button-control]",
})
export class CommonGroupButtonControlDirective implements AfterContentInit {
    @Input() public formManager: CommonFormManagerDirective;
    @Input() public fieldProp: string;
    @Input() public groupProp: string;
    @Input() public controlType = "new";
    @Input() public controlIndex: number;
    @Input() public groupContext: any;
    @Input() public isDisabledStyle = false;

    public groups: any[] = [];

    constructor(
        private ngRedux: ImmutableRedux<any>,
        @Inject(FORM_FIELD_GROUP_STATE_PROP) public rootProp,
    ) { }

    public ngAfterContentInit(): void {
        this.ngRedux.select(this.rootProp, this.groupProp).subscribe((state) => {
            this.groups = state.groups;
        });
    }

    @HostListener("click", ["$event"])
    public clickControl(e): void {
        e.stopPropagation();
        if (this.isDisabledStyle) {
            return;
        } else if (this.controlType === "new") {
            const ctx = this.groupContext || {};
            ctx.groupId = this.generateGroupId();
            ctx.isManuallyAddedGroup = true;
            this.formManager.addNewBlankGroup(this.rootProp, this.fieldProp, this.groupProp, ctx);
        } else if (this.controlType === "remove") {
            this.formManager.removeGroup(this.controlIndex, this.rootProp, this.fieldProp, this.groupProp);
        }
    }

    public generateGroupId(): number {
        if (this.groups.length === 0) {
            return 1;
        }
        const largestId = this.groups.map((group) => group.groupId).reduce((x, y) => Math.max(x, y));
        return largestId + 1;
    }
}
